import React from "react";
import PageWithNavbar from "@/components/PageWithNavbar";
import { Button } from "../components/ui/button";
import {
  CardContent,
  TransparentCard,
} from "../components/ui/card";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EmailVerifiedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageWithNavbar>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-md mx-auto">
            <div className="text-center mb-8">
                <div className="flex items-center justify-center mb-4">
                    <CheckCircle className="h-12 w-12 text-green-500 mr-3" />
                    <h1 className="text-3xl font-bold">Email Verified</h1>
                    </div>
                    <p className="text-muted-foreground">Your email has been successfully verified.</p>
                </div>

                <TransparentCard>
                    <CardContent>
                    <div className="text-center">
                        <Button onClick={() => navigate("/login")} className="w-full">Sign in</Button>
                    </div>
                    </CardContent>
                </TransparentCard>
          </div>
        </div>
      </div>
    </PageWithNavbar>
  );
};

export default EmailVerifiedPage;
